export default __webpack_public_path__ + "static/media/linkedin.59204961.png";